module.exports = __webpack_public_path__ + "media/images/cap_logo-748ec5fc465e7da7d764415362a51182.png";